export const UI_TRANSPORT_EVENT = 'acm:ui-transport';
export const UI_SLOW_RTT_MS = 1_500;
export const UI_RECOVERED_RTT_MS = 800;

export interface UiTransportSample {
  ok: boolean;
  latencyMs: number;
  gateway?: boolean;
}

export function reportUiTransportSample(sample: UiTransportSample): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<UiTransportSample>(UI_TRANSPORT_EVENT, { detail: sample }));
}

export function cacheBustedLocation(href: string, now = Date.now()): string {
  const url = new URL(href);
  url.searchParams.set('__acm_ui_recovered', String(now));
  return url.toString();
}

export function isUiGatewayResponse(response: Response): boolean {
  if (response.headers.has('x-acm-error-code')) return true;
  const contentType = response.headers.get('content-type') ?? '';
  return (response.status === 502 || response.status === 503) && contentType.includes('text/html');
}

export function disruptedProbeDelay(attempt: number, jitter = Math.random()): number {
  const exponent = Math.min(Math.max(0, Math.floor(attempt)), 3);
  const base = Math.min(1_500 * 2 ** exponent, 10_000);
  return base + Math.max(0, Math.min(jitter, 1)) * 750;
}
